export default __webpack_public_path__ + "assets/651084eb76a6b3a52f736b84fc69d0cc.svg";